import {
  doPostRequest,
  doPostRequestV2,
  doPostRequestV1,
  doGetRequestStep,
} from "./ApiService";
import { baseHeaders } from "./Headers";

export function newRegister(payload: any): Promise<any> {
  const url = `/acquisition?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  return doPostRequest<any>(url, payload, headers);
}

export function newRegisterV2(payload: any): Promise<any> {
  const url = `/acquisition?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  return doPostRequestV2<any>(url, payload, headers);
}

export function updateRegisterV2(payload: any): Promise<any> {
  const url = `/acquisition?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
  };
  return doPostRequestV2<any>(url, payload, headers);
}

export function updateRegister(payload: any): Promise<any> {
  const url = `/acquisition?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
  };
  return doPostRequestV1<any>(url, payload, headers);
}

export async function checkout(payload: any): Promise<any> {
  const url = `/acquisition/checkout?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  const response = await doPostRequestV1<any>(url, payload, headers);
  return response;
}

export async function checkoutV2(payload: any): Promise<any> {
  const url = `/acquisition/checkout?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  const response = await doPostRequestV1<any>(url, payload, headers);
  return response;
}

export function step(query: any): Promise<any> {
  const url = "/acquisition/step".concat(
    `?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`
  );
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetRequestStep(url, query, headers);
}
